import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import intl from "react-intl-universal";

import { TextField } from "components/TextField";

interface IPlayerToolbarProps {
  onUrlChange: (url: string) => void;
}

export const PlayerToolbar = ({ onUrlChange }: IPlayerToolbarProps) => {
  const [url, setUrl] = useState("");

  const hanndleLoad = () => {
    onUrlChange(url);
  };

  const handleUrlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(event.target.value);
  };
  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <Box mt={-1}>
          <TextField
            placeholder={intl.get("WITHBALL_INPUT_URL_PLACEHOLDER")}
            onChange={handleUrlChange}
            value={url}
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <span>
          <Button variant="contained" color="secondary" onClick={hanndleLoad}>
            {intl.get("WITHBALL_INPUT_VIDEO_LOAD_BUTTON")}
          </Button>
        </span>
      </Grid>
    </Grid>
  );
};
